import { render, staticRenderFns } from "./ApplicationPersonInfo2.vue?vue&type=template&id=db952440&scoped=true&"
import script from "./ApplicationPersonInfo2.vue?vue&type=script&lang=js&"
export * from "./ApplicationPersonInfo2.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPersonInfo2.vue?vue&type=style&index=0&id=db952440&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db952440",
  null
  
)

export default component.exports